import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ClearanceItem } from '../clearance-item.model';
import { PENDING_STATUSES } from '../../shared/helper-components/constants';

@Component({
    selector: 'bulk-bar',
    standalone: false,
    templateUrl: './clearance-item-bulkbar.component.html',
    styles: [`
        :host {
            display: inline-flex;
            flex-direction: row;
            align-items: center;
            gap: 2px;
        }
        .bulkbar-action {
            margin-right: 0;
        }
        .bulkbar-action mat-icon {
            color: rgba(0, 0, 0, 0.54);
        }
        .bulkbar-action:not(.disabled):hover mat-icon {
            color: rgba(0, 0, 0, 0.87);
        }
        .bulkbar-action.disabled mat-icon {
            color: rgba(0, 0, 0, 0.2);
        }
        /* Same transparent btn-flat as Search CLEAR / APPLY (baseline §9.1 / §9.4). */
        .bulkbar-cancel {
            text-transform: uppercase;
            background-color: transparent;
            color: rgba(51, 51, 51, 0.87);
            --mdc-text-button-label-text-color: rgba(51, 51, 51, 0.87);
            --mat-button-text-label-text-color: rgba(51, 51, 51, 0.87);
            --mat-button-text-state-layer-color: rgba(51, 51, 51, 0.87);
            --mat-text-button-state-layer-color: rgba(51, 51, 51, 0.87);
            --mat-button-text-container-shape: 2px;
        }
    `]
})
export class ClearanceItemBulkBarComponent {

    @Input()
    itemList: ClearanceItem[] = [];
    @Input()
    public isClearanceUser: boolean;
    @Input()
    public projectId: string;
    @Output()
    ModalInitializationRequested: EventEmitter<string> = new EventEmitter<string>();
    @Output()
    downloadImagesRequested: EventEmitter<void> = new EventEmitter<void>();
    @Output()
    selectionCancelled: EventEmitter<void> = new EventEmitter<void>();
    @Input()
    backActionVisible: boolean;
    @Input()
    downloadButtonVisible: boolean = true;
    @Input()
    readOnly: boolean = false;

    anyItemSelected(): boolean {
        return this.itemList && this.itemList.filter(it => it.isSelected).length > 0;
    }

    get tagsCanBeEdited(): boolean {
        let selectedItems = this.itemList.filter(it => it.isSelected);
        return selectedItems.length > 0 && (this.isClearanceUser || selectedItems.every(it => PENDING_STATUSES.has(it.status.toUpperCase())));
    }

    initializeModal(modalId: string) {
        this.ModalInitializationRequested.next(modalId);
    }

    enableStatusUpdateBatch(): boolean {
        let isSelected = this.itemList && this.itemList.filter(it => it.isSelected).length > 0 && this.isClearanceUser;
        return isSelected;
    }

    cancel() {
        this.itemList.forEach(i => {
            i.isSelected = false;
        });
        this.selectionCancelled.emit();
    }

    downloadImages() {
        this.downloadImagesRequested.emit();
    }
}
